module.exports = __webpack_public_path__ + "static/img/dg-dev.fc3ffcb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/dg-dev.svg
// module id = BeiO
// module chunks = 11